/**
 * @file 常见问题
 * @author chenyuyang
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import './index.less';

export class Help extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            type: false,
            step: 2,
            formData: {
                phoneMark: ''
            },
            checkboxValue: false
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    jump = (type) => {
        switch (type) {
            case 'partner':
                this.props.history.push('/partner');
                break;
            case 'userCenter':
                this.props.history.push('/user_center/my_attest');
                break;
            case 'guide':
                this.props.history.push('/companyGuide');
                break;
            case 'attest':
                this.props.history.push('/attest');
                break;
            case 'appeal':
                this.props.history.push('/appeal');
                break;
            default:
        }
    };

    render() {
        return (
            <div className={'help'}>
                <div className={'page-title'}>
                    常见问题：
                </div>

                <ul className={'con'}>
                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>为什么企业号码认证会被拒绝？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                企业号码认证被拒绝有以下3种情况：1.企业合法资质、运营商证明等提交不全或错误 2.企业名称与认证证明中的企业名称不一致
                                3.企业号码已被认证，如需更改认证信息，请进行
                                <span className="jump" onClick={() => this.jump('appeal')}>企业申诉</span>。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>如何知道企业/个人号码是否被用户标记为诈骗、骚扰等？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                在百度搜索中输入号码进行查询，若显示标记标签，则证明该号码已被百度用户标记；
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>为什么企业/个人号码在号码申诉时会被拒绝？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>企业/个人号码申诉被拒绝有以下2种情况：1.提交的申诉资料不全或错误 2、近期内确实存在较多用户标记，不予撤销。</div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>提交资料后，什么时候会审核完毕？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>提交资料后，工作人员会在提交后的两个工作日内审核完毕。特殊认证号码可在
                                <span className="jump" onClick={() => this.jump('userCenter')}>“个人中心”</span>
                                处查看审核结果。其他企业号码认证请联系
                                <span className="jump" onClick={() => this.jump('partner')}>合作伙伴</span>。</div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>企业/个人号码申诉成功后，为什么百度搜索或通话时还会显示标记？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                申诉成功后，百度搜索显示标记是由于搜索中的数据需等待数据更新后才能不再显示，
                                存在一定的延迟，请耐心等待；通话时还在显示标记时，您可以在通话列表中点击进入号码详情，
                                根据页面中显示的数据标记来源，到相应的数据来源方官网进行标记申诉。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>百度号码服务平台是否会泄露企业/个人身份信息？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                百度号码服务平台是国内著名号码安全平台，首先保证的就是您手机中各类信息的安全，
                                对于您提交的有关信息，我们会进行严格保密，不会泄露任何信息，请您放心提交。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>举报后的号码将会如何处理？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>当号码被举报次数超过一定量时，将会把该号码正式标记为相关类型，以展示给百度用户。</div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>如何快速进行企业认证</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                可以通过地方的官方合作伙伴帮您进行一对一的指导认证，
                                <span className="jump" onClick={() => this.jump('partner')}>点击查看详情</span>
                            </div>
                        </div>
                    </li>
                    {/* 认证常见问题 */}
                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>百度企业号码认证是什么？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                百度安全团队企业号码认证服务，搜索+来电名片全场景覆盖，
                                当网民搜索企业号码相关关键词时展示企业号码认证相关信息的号码卡。
                                通过严格的审核流程和智能的风控技术确保了企业号码的安全性。
                                本服务保护企业品牌不受虚假欺诈电话的损害，搭建用户与企业之间安全沟通的信任桥梁。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>百度企业号码认证有什么价值？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                <p>1、百度搜索结果卡片：在百度搜索企业名称加“号码、客服、电话等”关键字时，
                                将认证企业号码信息呈现在搜索结果页，包括认证标识、品牌名称、logo、号码等，提升企业权威形象，提高企业号码信息的可信度。</p>
                                <p>2、企业专属号码卡片：点击企业号码卡片，可跳转企业专属号码落地页，展示企业宣传图、简介等详细信息，提升企业品牌曝光，突显企业专业度。</p>
                                <p>3、多平台来电显示：在用户的手机端展示企业品牌、号码关联和宣传服务。企业号码可在通话记录中显示，提升可信度，避免「广告」、「骚扰」类标签影响接通率，
                                    降低跟风投诉量。提高用户辨识度，用户有需求时可迅速查询回拨，增加企业品牌二次成单。</p>
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>如何认证我的企业电话号码？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                <p>1、在百度号码服务平台，提交您企业的信息及联系方式，
                                    <span className="jump" onClick={() => this.jump('attest')}>点击进入</span>
                                </p>
                                <p>2、百度<span className="jump" onClick={() => this.jump('partner')}>官方合作伙伴</span>
                                    将与您电话联系，为您提供一对一协助，进行号码认证服务。查看
                                    <span className="jump" onClick={() => this.jump('guide')}>认证资质所需材料。</span></p>
                                <p>3、认证资质审核通过，完成付费，您的企业号码认证顺利上线。</p>
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>是否可以在线自主认证企业号码？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                您可以在线进行自主认证，但由于百度官网自主认证流程较复杂，产品价格无优惠，建议您通过填写
                                <span className="jump" onClick={() => this.jump('attest')}>认证信息</span>，
                                提交后由百度<span className="jump" onClick={() => this.jump('partner')}>官方合作伙伴</span>
                                电话联系您协助认证，提供专属答疑和售后服务；如果您所在区域没有官方合作伙伴，您可以通过百度云平台进行在线自主认证，点击可查看
                                <span className="jump" onClick={() => this.jump('guide')}>自主认证教程</span>。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>认证企业号码需要哪些材料？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                查看<span className="jump" onClick={() => this.jump('guide')}>认证资质所需材料。</span>
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>企业号码认证如何收费？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                按年计费包年服务，您可以提交企业的信息到平台，平台会自动为您计算费用，或者您可以找您当地
                                <span className="jump" onClick={() => this.jump('partner')}>合作伙伴</span>为您线下评估
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>提交联系信息后，什么时候会和我联系？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                合作伙伴会在7个工作日内与您联系。如果超过7日未获得联系，您可以发送邮件至haomakefu@baidu.com进行咨询，平台会直接为您提供服务。
                            </div>
                        </div>
                    </li>

                    <li>
                        <i className="disc"/>
                        <div className="question">
                            <div>Q：</div>
                            <div>我的企业号码被错误标记，怎么办？</div>
                        </div>
                        <div className="answer">
                            <div>A：</div>
                            <div>
                                您可以通过<span className="jump" onClick={() => this.jump('appeal')}>号码标记申诉</span>，
                                在线取消错误的号码标记显示。如果您希望在百度搜索中展示您企业的正确品牌和号码，您可以
                                <span className="jump" onClick={() => this.jump('attest')}>填写联系方式</span>进行企业号码认证。
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        );
    }
}

Help.propTypes = {
    history: PropTypes.object,
};

function mapStateToProps() {
    return {};
}

function mapDispatchToProps() {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Help));